class FaqSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = document.querySelector('#faq-search');
      this.SearchResults = this.querySelector('[data-predictive-search]');
      this.copyIcons= document.querySelectorAll('#copy-faq-article-icon');
      this.copyIcons.forEach(btn => btn.addEventListener('click', this.copyFaqs.bind(this)));
      this.searchTerm = '';
      this.ManageOnload();  
      this.setupEventListeners();
      document.querySelector('#faq-page').addEventListener('click', (_event)=>{
        
        if (_event.target == this.input) {
          _event.preventDefault();
          return false
        }
        this.SearchResults.classList.add('d-none');
      });
    }
  
    ManageOnload(){
    const href = window.location.href;
    const id = href.includes('#') ? href.split('#')[1] : null;

    if (id) {
      // Target the element with the extracted ID
      const targetElement = document.querySelector(`#${id}`);
      
      if (targetElement) {
        // Find the closest parent element with the class '.parent-faq'
        const ParentElement = targetElement.closest('.parent-faq');
        
        if (ParentElement) {
          ParentElement.classList.add('open');
          
          const toggleContent = ParentElement.querySelector('.toggle-content');
          if (toggleContent) toggleContent.classList.add('open');
        }

        // Add 'open' class to the target element and its toggle content
        targetElement.classList.add('open');
        const targetToggleContent = targetElement.querySelector('.toggle-content');
        if (targetToggleContent) targetToggleContent.classList.add('open');

        // Determine scroll offset based on screen size
        const scrollOffset = window.matchMedia("(max-width: 768px)").matches ? 20 : 40;

        // Scroll to the target element with offset
        window.scrollTo({
          top: targetElement.getBoundingClientRect().top + window.scrollY - scrollOffset,
          behavior: 'smooth' // Smooth scrolling effect
        });
      }
    }

    }
    copyFaqs(event){
      event.preventDefault();
      event.stopPropagation();
      let currentTarget = event.currentTarget;
      navigator.clipboard.writeText(currentTarget.getAttribute('link'));
      currentTarget.querySelector('.tooltiptext').innerText = 'Copied';
      setTimeout(() => {
        currentTarget.querySelector('.tooltiptext').innerText = 'Copy to clipboard';
      },2000);
    }

    /**
     * Bind the events on the search input
     */
    setupEventListeners() {
      if (this.input) {
        this.input.addEventListener('input', Utility.debounce((event) => {
          this.onChange(event);
        }, 500).bind(this))
      }

      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }
  
    /**
     * 
     * @returns Search Query with trim value
     */
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
        const newSearchTerm = this.getQuery();

        
  
        this.searchTerm = newSearchTerm;
        this.getSearchResults(this.searchTerm);
    }
  
    /**
     * Trigger Form Submit event
     * @param {*} event 
     */
  
    onFormSubmit(event) {
      event.preventDefault();
    }
  
    /**
     * Search term was changed from other search input, treat it as a user change
    */
    onFocus() {
      const currentSearchTerm = this.getQuery();
  
      if (!currentSearchTerm.length) return;
  
      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      }else {
        this.getSearchResults(this.searchTerm);
      }
    }
  
    /**
     * Call Sections APIs for search results
     * @param {*} searchTerm 
     */
    getSearchResults(searchTerm) {
      const faqItems = document.querySelectorAll('.faq-item');
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      let html = '';
      
      // Check if the search term is empty
      if (searchTerm.trim() === '') {
        this.SearchResults.classList.add('d-none');
        return false;
      } else {
          // Filter FAQ items based on the search term
          const matchingItems = [...faqItems].filter(item => {
              const question = item.querySelector('.faq-question').textContent.toLowerCase();
              return question.includes(searchTerm.toLowerCase());
          });
      
          // Generate HTML for matching items or show "No results found"
          if (matchingItems.length > 0) {
              matchingItems.forEach(item => {
                  html += `<a class="d-block anchor-link mb-1" href="#${item.getAttribute("id")}">${item.querySelector('.faq-question p').textContent}</a>`;
              });
          } else {
              html = '<span>No results found</span>';
          }
      }
      
      // Update the search results container
      this.SearchResults.innerHTML = html;
      this.SearchResults.classList.remove('d-none');
      
      // Cache the results if not already cached
      if (!this.cachedResults[queryKey] && searchTerm.trim() !== '') {
          this.cachedResults[queryKey] = html;
      }
      
      this.SearchResults.querySelectorAll('a').forEach(btn => btn.addEventListener('click', this.manageFAQtoggle.bind(this)));
    }  
  
    manageFAQtoggle(event){
      event.preventDefault();
      let currentTarget = event.currentTarget; 
      let divID = currentTarget.getAttribute('href'), 
      targetElement = document.querySelector(`${divID}`);

      if (targetElement) {
        let ParentElement = targetElement.closest('.parent-faq');
        
        if (ParentElement) {
          ParentElement.classList.add('open');
          let toggleContent = ParentElement.querySelector('.toggle-content');
          if (toggleContent) toggleContent.classList.add('open');
        }

        this.SearchResults.classList.add('d-none');
        targetElement.classList.add('open');
        let targetToggleContent = targetElement.querySelector('.toggle-content');
        if (targetToggleContent) targetToggleContent.classList.add('open');

        // Determine scroll offset based on screen size
        const scrollOffset = window.matchMedia("(max-width: 768px)").matches ? 20 : 40;

        // Scroll to the target element with offset
        window.scrollTo({
          top: targetElement.getBoundingClientRect().top + window.scrollY - scrollOffset,
          behavior: 'smooth' // Smooth scrolling effect
        });
      }      

    }

    /**
     * Show Search results container
     */
    showResults(){
        this.predictiveSearchResults.classList.add('show-results');
    }
}
  
customElements.define('faq-search', FaqSearch);
  